import { IFs } from "memfs";

export const DRIZZLE_CONFIG_FILES = [
  "drizzle.config.ts",
  "drizzle.config.js",
  "drizzle.config.mjs",
  "drizzle.config.json"
];

export const DOCKER_COMPOSE_FILES = [
  "compose.yml",
  "compose.yaml",
  "docker-compose.yml",
  "docker-compose.yaml"
];

export const COMPOSER_JSON_FILES = ["composer.json"];

/** Some speficic, well known file groups which can be available */
export enum Available {
  dockerCompose = "dockerCompose",
  packageJson = "packageJson",
  viteConfig = "viteConfig",
  goConfig = "goConfig",
  nextConfig = "nextConfig",
  drizzleConfig = "drizzleConfig",
  prismaSchema = "prismaSchema",
  gradleConfig = "gradleConfig",
  composerJson = "composerJson",
  denoConfig = "denoConfig"
}

type CheckerTuple = [
  Available,
  { matcher: (files: string[], fs: IFs, path: string) => boolean; files: string[] }
];

/** Build checkers for those well-known files, frameworks or language features */
export const buildAvailabilityChecks = (): CheckerTuple[] => {
  const matcher = (files: string[], fs: IFs, path: string) =>
    files.some(f => fs.existsSync(path + "/" + f));
  return [
    [
      Available.dockerCompose,
      {
        matcher,
        files: DOCKER_COMPOSE_FILES
      }
    ],
    [
      Available.packageJson,
      {
        matcher,
        files: ["package.json"]
      }
    ],
    [
      Available.viteConfig,
      {
        matcher,
        files: ["vite.config.ts", "vite.config.js", "vite.config.mjs"]
      }
    ],
    [
      Available.goConfig,
      {
        matcher,
        files: ["go.mod", "go.sum"]
      }
    ],
    [
      Available.nextConfig,
      {
        matcher,
        files: ["next.config.js", "next.config.mjs", "next.config.ts", "next.config.cjs"]
      }
    ],
    [
      Available.drizzleConfig,
      {
        matcher,
        files: DRIZZLE_CONFIG_FILES
      }
    ],
    [
      Available.prismaSchema,
      {
        matcher: (_, fs, path) =>
          fs.existsSync(path + "/prisma") &&
          fs.statSync(path + "/prisma").isDirectory() &&
          fs.existsSync(path + "/prisma/schema.prisma"),
        files: ["prisma", "prisma/schema.prisma"]
      }
    ],
    [
      Available.gradleConfig,
      {
        matcher,
        files: ["settings.gradle", "build.gradle"]
      }
    ],
    [
      Available.composerJson,
      {
        matcher,
        files: COMPOSER_JSON_FILES
      }
    ],
    [
      Available.denoConfig,
      {
        matcher,
        files: ["deno.json", "deno.jsonc"]
      }
    ]
  ];
};
